module.exports = __webpack_public_path__ + "img/library-hamburguer-menu.f1dec4e8.svg";